function getActiveFacesheetTab(pathname = '') {
  const [sanitizedPathname] = pathname.split('?');
  const pathSegments = sanitizedPathname.split('/').filter(Boolean);
  const facesheetSegmentIndex = pathSegments.indexOf('facesheet');

  if (facesheetSegmentIndex === -1) {
    return 'overview';
  }

  const tabSegment = pathSegments[facesheetSegmentIndex + 2];

  const routeTabMappings = {
    'resource-lists': 'resource',
    'social-care-plan': 'socialCarePlan',
  };

  return routeTabMappings[tabSegment] || tabSegment || 'overview';
}

export default getActiveFacesheetTab;
